import React from 'react';
import {Card, ListGroup} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

// Number formatter.
var formatter = new Intl.NumberFormat('nl-BE', {
    style: 'currency',
    currency: 'EUR',
  });
  

function MenuCategory({categorie, lang}) {

    let name = JSON.parse(categorie.name);
    let {t} = useTranslation();

    return (
        <Card >
            <Card.Body>
            <Card.Title id={name[lang]} className="lead text-uppercase text-center container-fluid section">{name[lang]}</Card.Title>
                <div className="px-md-2" >
                    <div className="container-md">
                {
                    categorie.menuItems.map((menuItem, i) => {
                        let menuItemName = JSON.parse(menuItem.name)
                        let menuItemDescription = JSON.parse(menuItem.description)
                    return <div key={i} className="row mb-4">
                                <div className="col col-12 col-md-9">
                                    <div className=" font-weight-normal text-uppercase mb-2" >{menuItemName[lang]}</div>
                                    {
                                        (menuItemDescription[lang] !== null ) && <div className="ingredients  mb-2 "dangerouslySetInnerHTML={{__html: menuItemDescription[lang].replace(/(?:\r\n|\r|\n)/g, '<br />')}}></div> 
                                    }
                                    {
                                        (menuItem.allergens.length > 0) &&
                                        <div className="text-muted"  style={{ fontSize: "0.8rem"}} >
                                            <span>{t("Allergens")}:&nbsp;</span>
                                        {
                                            menuItem.allergens.map((allergy, i) => {
                                            let allergyname = JSON.parse(allergy.name)
                                            return <span className="allergies text-muted" key={i}>{allergyname[lang]}<span>,&nbsp;</span></span>
                                            })
                                        }
                                        </div>
                                    }
                                </div>                                
                                <div className="col col-12 col-md-3 text-right text-muted price">{formatter.format(menuItem.price)}</div>
                        </div>
                    })
                }</div>
                </div>
            </Card.Body>
        </Card>
        );
}

export default MenuCategory;
